import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9b48e68"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "history-order"
}
const _hoisted_2 = { class: "history-order__number" }
const _hoisted_3 = { class: "history-order__products" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "default-message" }, " Você não possui nenhum histórico de pedidos. ", -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.orders.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orders, (order, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("span", _hoisted_2, "Pedido: " + _toDisplayString(order.id), 1),
              _createElementVNode("span", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.products, (product, index) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: "history-order__products",
                    key: index
                  }, _toDisplayString(product.name), 1))
                }), 128))
              ]),
              _createElementVNode("span", null, _toDisplayString($setup.formattedDate(order.createAt)), 1),
              _createElementVNode("span", null, "Quantidade: " + _toDisplayString(order.quantity), 1),
              _createElementVNode("span", null, "Total: " + _toDisplayString(order.grossValue) + " Decoins", 1),
              _createElementVNode("span", null, [
                _createElementVNode("button", {
                  class: "history-order__button",
                  onClick: ($event: any) => ($setup.generateNewReceipt(order.id))
                }, " comprovante ", 8, _hoisted_4)
              ])
            ]))
          }), 128))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
}